import { useStore } from '@gx-vuex'
import { isDev } from '@/utils/env'

export function useEchart(types: 'mobile' | 'pc') {
  const store = useStore()

  const echartList = ref([])

  const echartRemove = () => {
    echartList.value.forEach(el => {
      if (el && el.dispose) {
        el.dispose()
      }
    })
    echartList.value = []
  }

  const start = () => {
    try {
      initEchart(echartOptions)
    } catch (e) {
      if (isDev()) {
        initEchart(store.global.details.newsContentBak ? JSON.parse(store.global.details.newsContentBak) : {})
      }
    }
  }

  const initEchart = (echartOptions) => {
    // @ts-ignore
    echarts.registerTransform(ecStat.transform.regression)
    // @ts-ignore
    Object.values(echartOptions).map((item: any) => {
      const dom = document.querySelector(`#${item.id}`)
      if (dom) {
        const type = item.option.series[0].type
        const title = item.option.title ? item.option.title.text || '' : ''
        let yValueName = ''

        const isScatter = item.option.series && item.option.series.length === 2
        const seriesObjSecond = item.option.series ? item.option.series[1] : {}

        item.option.yAxis = item.option && item.option.yAxis ? item.option.yAxis[0] : {}
        item.option.yAxis.offset = 0
        if (isScatter) {
          item.option.yAxis.nameTextStyle = {}
          item.option.yAxis.nameTextStyle.align = 'left'
          if (types === 'pc') {
            item.option.yAxis.nameTextStyle.fontSize = 14
          }
          item.option.yAxis.nameTextStyle.padding = [ 0, 0, 0, -34 ]
          yValueName = item.option.yAxis.name
          delete item.option.yAxis.name
        } else {
          yValueName = item.option.yAxis.name
          delete item.option.yAxis.name
        }

        dom.outerHTML = `<div class="en-echart">${!!title ?
          `<div class="en-echart-title droidSerif-bold">${item.option.title.text}</div>` : ''}${!!yValueName ? `<div class="en-echart-yname">${yValueName}</div>` : ''}<div class="" style="width: ${types === 'pc' ? '890px' : '100%'}; height: ${types === 'pc'
          ? `${type === 'pie' ? 350 : 466}px`
          : `${type === 'pie' ? 5 : 6.29333}rem`}; margin: 0 auto;" id="${item.id}"></div></div>`
        const dom2 = document.querySelector(`#${item.id}`)
        // @ts-ignore
        const chart = echarts.init(dom2, null, {
          renderer: 'svg',
          useDirtyRect: false
        })

        echartList.value.push(chart)
        delete item.option.title
        if (isScatter) {
          renderScatter(chart, item)
        } else {
          const areaStyle = item.option.series[0].areaStyle
          if (areaStyle) {
            item.option.xAxis = item.option.xAxis[0]
          }
          const pie = type === 'pie' ? {
            avoidLabelOverlap: false,
            label: {
              normal:
                {
                  position: 'inner',
                  formatter: '{d}%',
                  fontWeight: 'normal',
                  fontFamily: 'DroidSerif',
                  fontSize: types == 'mobile' ? `${10/37.5}rem` : '14px',
                  color: '#fff'
                }
            },
            labelLine: {
              show: false
            },
            tooltip: {
              trigger: 'item',
              formatter: '{b}:{c} ({d}%)'
            }
          } : {}
          chart.setOption({
            ...item.option,
            grid: {
              containLabel: true,
              left: '0%',
              right: '5%',
              top: type === 'pie' ? '0%' : types === 'mobile' ? '6%' : '2%',
              bottom: '5%',
            },
            dataset: [
              {
                // @ts-ignore
                source: item.option.dataset ? item.option.dataset[0].source : ''
              },
              {
                transform: {
                  type: 'ecStat:regression',
                  config: {
                    method: 'exponential'
                  }
                }
              }
            ],
            legend: type === 'pie' ? {
              left: -5,
              borderRadius: 0,
              orient: 'vertical',
              textStyle: {
                fontStyle: 'DroidSerif',
              },
              top: 'center'
            } : undefined,
            series: [
              {
                // @ts-ignore
                ...item.option.series[0],
                radius: [ '40%', '90%' ],
                itemStyle: type === 'line' ? {
                  'color': '#B71D26',
                  'lineStyle': {
                    'color': '#B71D26'
                  }
                } : undefined,
                center: type === 'pie' ? [ '74%%', '50%' ] : null,
                symbol: type === 'line' ? 'circle' : type === 'scatter' ? seriesObjSecond.symbol : '',
                symbolSize: type === 'line' ? '7' : type === 'scatter' ? seriesObjSecond.symbolSize : '',
                areaStyle: type === 'line' && !!areaStyle ? {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(183,29,38,0.50)' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgba(183,29,38,0.00)' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                } : undefined,
                ...pie
              }
            ]
          })
        }
      }
    })
  }

  const renderScatter = (chart, item) => {
    chart.setOption({
      ...item.option,
      grid: {
        containLabel: true,
        left: '0%',
        top: types === 'mobile' ? '15%' : '8%',
        bottom: '10%',
      },
      dataset: item.option.dataset,
      series: [
        {
          ...item.option.series[0]
        },
        {
          ...item.option.series[1],
          labelLayout: types === 'mobile' ? { dx: -60, dy: -10 } : {}
        }
      ]
    })

  }

  return {
    start,
    echartRemove
  }
}
